import type { AudioDevice } from "../../audio/deviceEnumerator";

// 入出力デバイスの selectbox (spec §4.4 Step 2/3)。列挙・切替の副作用は持たない
// controlled component (親 = Preflight が deviceEnumerator / switchDevice を配線する)。
// value="" は「既定のデバイス」。選択すると onSelect(null) で既定へ戻せる。
type Props = {
  label: string;
  devices: AudioDevice[];
  selectedId: string | null; // null = OS 既定
  onSelect: (deviceId: string | null) => void;
  /** 救済手段として強調するか (D26-5)。既定は false で従来の見た目のまま */
  highlighted?: boolean;
};

export function DeviceSelect({ label, devices, selectedId, onSelect, highlighted = false }: Props) {
  return (
    <label className="flex flex-col gap-1 text-xs text-slate-600">
      {label}
      <select
        value={selectedId ?? ""}
        onChange={(e) => {
          onSelect(e.target.value === "" ? null : e.target.value);
        }}
        /* text-base = 16px: iOS Safari は 16px 未満の入力欄に focus すると画面を強制ズームし、
           以降ヘッダもマイクも画面外へ出る。min-h-[44px] は HIG のタップ領域 44pt の確保 */
        className={`w-full bg-white border rounded-lg px-3 py-2 text-base text-slate-900 min-h-[44px] focus:outline-none focus:ring-2 focus:ring-indigo-300 ${
          highlighted ? "border-indigo-500 ring-2 ring-indigo-200" : "border-slate-300"
        }`}
      >
        <option value="">既定のデバイス</option>
        {devices.map((d) => (
          <option key={d.deviceId} value={d.deviceId}>
            {d.label}
          </option>
        ))}
      </select>
    </label>
  );
}
